export enum UnderwriterRole {
  Any = 'Any',
  LeadLeft = 'Lead Left',
  Bookrunner = 'Bookrunner',
  CoManager = 'Co-manager',
}
